import { useState } from "react";
import { baseUrlConfig } from "../../configurations/configurations";

export const useForgotPassword = () => {
  const { API_ROOT_URL } = baseUrlConfig.development;
  const [fetchResponseStatus, setFetchResponseStatus] = useState({
    error: false,
    loading: false,
    success: false,
  });

  const forgotPassword = async ({ email, language }) => {
    setFetchResponseStatus({ loading: true, error: false, success: false });
    try {
      const formData = new URLSearchParams();
      formData.append("email", email);

      const response = await fetch(
        `${API_ROOT_URL}/oauth/forgot-password?language=${language}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formData,
        }
      );

      if (!response.ok) {
        setFetchResponseStatus({ loading: false, error: true, success: false });
      } else {
        setFetchResponseStatus({ loading: false, error: false, success: true });
      }
    } catch (error) {
      console.error("Forgot password failed:", error);
      setFetchResponseStatus({ loading: false, error: true });
    }
  };

  return { fetchResponseStatus, forgotPassword };
};
